import { useQuery } from "react-query";
import { SrxApi } from "../api/SrxApi";

const useGetVersions = (pageNumber = 1, pageSize = 10) => {
  const getAllVersions = async () => {
    const response = await SrxApi.get("/versions", {
      params: {
        pageNumber,
        pageSize
      }
    });
    return response?.data ?? { items: [], totalCount: 0, pageNumber: 1, pageSize: 10, totalPages: 0 };
  };

  const {
    data: getAllVersion = { items: [], totalCount: 0, pageNumber: 1, pageSize: 10, totalPages: 0 },
    isFetching: getAllVersionLoading,
  } = useQuery(
  ["getAllVersion", pageNumber, pageSize],
  getAllVersions,
  {
    staleTime: 0,             
    refetchOnWindowFocus: true
  }
);

  return {
    getAllVersion,
    getAllVersionLoading,
  };
};

export default useGetVersions;
